import { useEffect } from 'react';

/**
 * /recert -> the recert sign-in page.
 *
 * The recert app (housing-compliance-service, src/recert) lives on the portal
 * subdomain so its sign-in sessions and Microsoft redirects stay on one origin.
 * This route is deliberately not linked from the
 * navigation yet; agencies reach it by URL.
 */
const RECERT_LOGIN = process.env.REACT_APP_RECERT_URL || 'https://portal.gethousingai.com/recert';

export default function RecertRedirectPage() {
  useEffect(() => { window.location.replace(RECERT_LOGIN); }, []);
  return (
    <div className="min-h-screen flex items-center justify-center text-gray-500">
      Opening the recertification workspace…
    </div>
  );
}
